export default __webpack_public_path__ + "96e67f4c43f52acf883265be4d40fdbf.png";